import { useQuery } from "@tanstack/react-query";
import {
  fetchAccountList,
  fetchAccountOverview,
  fetchAccountActivitySummary,
  type AccountListQuery,
} from "@/api/accounts";

const ONE_MINUTE = 60_000;

export function useAccountList(query: AccountListQuery) {
  return useQuery({
    // D-150 Q2: cache key uses the literal requested scope ("" when unset) — the
    // old `?? "assigned"` default collided unset-scope and assigned-scope entries.
    queryKey: ["accountList", query.offset ?? 0, query.search ?? "", query.scope ?? "", query.segment ?? ""],
    queryFn: ({ signal }) => fetchAccountList(query, signal),
    staleTime: ONE_MINUTE,
  });
}

export function useAccountOverview(id: string | undefined) {
  return useQuery({
    queryKey: ["accountOverview", id],
    queryFn: ({ signal }) => fetchAccountOverview(id!, signal),
    enabled: !!id,
    staleTime: ONE_MINUTE,
  });
}

export function useAccountActivitySummary(
  id: string | undefined,
  filter: string = "all",
  offset: number = 0,
) {
  return useQuery({
    queryKey: ["accountActivitySummary", id, filter, offset],
    queryFn: ({ signal }) =>
      fetchAccountActivitySummary(id!, { offset, limit: 20, filter }, signal),
    enabled: !!id,
    staleTime: ONE_MINUTE,
  });
}
